import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const AdminDashboard = () => {
  const [metrics, setMetrics] = useState({ totalUsers: 0, totalDirectorios: 0, totalFacturas: 0 });
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  // URL base apuntando al backend de carga real en Azure
  const API_BASE_URL = 'https://app-andromeda-get-be-f2fwhsgsbehmagf0.westus3-01.azurewebsites.net/api/admin';
  
  // ... (El resto del código hacia abajo se mantiene exactamente igual)


  const fetchData = async () => {
    setLoading(true);
    const token = sessionStorage.getItem('token');
    const config = {
      headers: { Authorization: `Bearer ${token}` }
    };

    try {
      const [metricsRes, usersRes] = await Promise.all([
        axios.get(`${API_BASE_URL}/dashboard-metrics`, config),
        axios.get(`${API_BASE_URL}/users-management`, config)
      ]);

      setMetrics(metricsRes.data);
      setUsers(usersRes.data);
      setError(null);
    } catch (err) {
      console.error('Error fetching admin data:', err);
      setError('Error al cargar los datos de administración.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleUpgrade = async (empresaId) => {
    if (!window.confirm('¿Estás seguro de que deseas actualizar el plan de esta empresa a Personal?')) {
      return;
    }

    const token = sessionStorage.getItem('token');
    try {
      await axios.put(`${API_BASE_URL}/upgrade-plan/${empresaId}`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert('Plan actualizado con éxito 🚀');
      fetchData(); // Refrescar datos para actualizar la UI
    } catch (err) {
      console.error('Error upgrading plan:', err);
      alert('Hubo un error al intentar actualizar el plan.');
    }
  };

  if (loading && users.length === 0) {
    return <div style={{ padding: '40px', textAlign: 'center' }}>Cargando panel de administración...</div>;
  }

  return (
    <div className="admin-container" style={{ padding: '20px', backgroundColor: '#f4f7f6', minHeight: '100vh', fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif' }}>
      <header style={{ marginBottom: '30px', borderBottom: '2px solid #007A33', paddingBottom: '10px' }}>
        <button 
          onClick={() => navigate('/dashboard')}
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'transparent',
            color: '#007A33',
            border: 'none',
            padding: '8px 0',
            cursor: 'pointer',
            fontWeight: '600',
            fontSize: '1em',
            marginBottom: '10px',
            transition: 'color 0.2s'
          }}
          onMouseOver={(e) => e.target.style.color = '#005a26'}
          onMouseOut={(e) => e.target.style.color = '#007A33'}
        >
          ← Regresar al Dashboard
        </button>
        <h1 style={{ color: '#007A33', margin: 0 }}>Andromeda Administration</h1>
        <p style={{ color: '#666' }}>Panel de gestión y métricas del sistema</p>
      </header>

      {error && (
        <div style={{ backgroundColor: '#fee2e2', color: '#dc2626', padding: '15px', borderRadius: '8px', marginBottom: '20px' }}>
          {error}
        </div>
      )}

      {/* KPI Section */}
      <section className="kpi-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '40px' }}>
        <div className="kpi-card" style={kpiCardStyle}>
          <span style={kpiLabelStyle}>Usuarios Registrados</span>
          <span style={kpiValueStyle}>{metrics.totalUsers}</span>
        </div>
        <div className="kpi-card" style={kpiCardStyle}>
          <span style={kpiLabelStyle}>Directorios Totales</span>
          <span style={kpiValueStyle}>{metrics.totalDirectorios}</span>
        </div>
        <div className="kpi-card" style={kpiCardStyle}>
          <span style={kpiLabelStyle}>Facturas Procesadas</span>
          <span style={kpiValueStyle}>{metrics.totalFacturas}</span>
        </div>
      </section>

      {/* Users Table */}
      <section className="table-section" style={{ backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
        <div style={{ padding: '20px', borderBottom: '1px solid #eee' }}>
          <h2 style={{ fontSize: '1.2em', margin: 0, color: '#333' }}>Listado de Clientes</h2>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
            <thead>
              <tr style={{ backgroundColor: '#f9fafb', color: '#4b5563', textTransform: 'uppercase', fontSize: '0.85em', fontWeight: '600' }}>
                <th style={thStyle}>Usuario</th>
                <th style={thStyle}>Empresa / Razón Social</th>
                <th style={thStyle}>Email</th>
                <th style={thStyle}>Rol</th>
                <th style={thStyle}>Plan Actual</th>
                <th style={thStyle}>Fecha Registro</th>
                <th style={thStyle}>Directorios</th>
                <th style={thStyle}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id} style={{ borderBottom: '1px solid #f3f4f6', fontSize: '0.95em' }}>
                  <td style={tdStyle}>{user.username}</td>
                  <td style={tdStyle}>{user.razon_social || 'N/A'}</td>
                  <td style={tdStyle}>{user.email || '-'}</td>
                  <td style={tdStyle}>
                    <span style={{ 
                      fontWeight: user.role === 'superadmin' ? 'bold' : 'normal',
                      color: user.role === 'superadmin' ? '#007A33' : '#4b5563'
                    }}>
                      {user.role}
                    </span>
                  </td>
                  <td style={tdStyle}>
                    <span style={{ 
                      padding: '4px 10px', 
                      borderRadius: '20px', 
                      fontSize: '0.85em',
                      backgroundColor: user.plan_id === 2 ? '#dcfce7' : '#fef9c3',
                      color: user.plan_id === 2 ? '#166534' : '#854d0e'
                    }}>
                      {user.plan_id === 2 ? 'Personal' : 'Trial'}
                    </span>
                  </td>
                  <td style={tdStyle}>{user.created_at ? new Date(user.created_at).toLocaleDateString('es-ES') : '-'}</td>
                  <td style={tdStyle}>{user.directorios_count}</td>
                  <td style={tdStyle}>
                    {user.plan_id === 1 && (
                      <button 
                        onClick={() => handleUpgrade(user.empresa_id)}
                        style={{
                          backgroundColor: '#007A33',
                          color: 'white',
                          border: 'none',
                          padding: '8px 14px',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontWeight: '600',
                          fontSize: '0.85em',
                          transition: 'background-color 0.2s'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#005a26'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#007A33'}
                      >
                        🚀 Upgrade a Personal
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

// Styles
const kpiCardStyle = {
  backgroundColor: 'white',
  padding: '25px',
  borderRadius: '12px',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
  borderLeft: '5px solid #007A33'
};

const kpiLabelStyle = {
  color: '#6b7280',
  fontSize: '0.9em',
  fontWeight: '500',
  marginBottom: '10px'
};

const kpiValueStyle = {
  color: '#111827',
  fontSize: '2em',
  fontWeight: 'bold'
};

const thStyle = {
  padding: '15px 20px',
  borderBottom: '2px solid #f3f4f6'
};

const tdStyle = {
  padding: '15px 20px',
  color: '#374151'
};

export default AdminDashboard;